import { useMemo } from 'react';

import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import type { RoomManagersMap } from 'hooks/useRoomManagersWrite/useRoomManagersWrite';
import { CustomMeedioMatrixEvents } from 'utils/matrixUtils';

export interface RoomManagersInitialState {
  type: typeof CustomMeedioMatrixEvents.ROOM_MANAGERS;
  state_key: '';
  content: {
    managers: RoomManagersMap;
  };
}

const useRoomManagersInitialState = (workspaceId: string | null): RoomManagersInitialState | null => {
  const { matrixClient } = useMatrixContext();

  return useMemo<RoomManagersInitialState | null>(() => {
    if (!workspaceId) return null;

    const currentUserId = matrixClient.getUserId();
    const managers: RoomManagersMap = {};

    if (currentUserId) {
      managers[currentUserId] = { reason: 'creator' };
    }

    return {
      type: CustomMeedioMatrixEvents.ROOM_MANAGERS,
      state_key: '',
      content: { managers },
    };
  }, [matrixClient, workspaceId]);
};

export default useRoomManagersInitialState;
